import ClusterIcon from './ClusterIcon';
import ClusterTooltip from './ClusterTooltip';

function TikTokEmptyClusterIconWithTooltip() {
    return (
        <ClusterTooltip cluster="tiktok no cluster" dataSource="tiktok">
            <ClusterIcon cluster="tiktok no cluster" />
        </ClusterTooltip>
    );
}

export default TikTokEmptyClusterIconWithTooltip;
